import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

interface Props {
  value: string;
  onChange: (q: string) => void;
  className?: string;
  inputClassName?: string;
}

// Product search box shared by the spreadsheet toolbars.
export default function ProductSearchInput({ value, onChange, className, inputClassName }: Props) {
  return (
    <div className={cn("relative flex-1 min-w-[160px] max-w-xs", className)}>
      <span
        className="absolute inset-y-0 left-2.5 flex items-center pointer-events-none"
        style={{ color: "var(--chart-muted)" }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <circle cx="5" cy="5" r="3.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M7.5 7.5L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search products..."
        style={{ background: "var(--background)", borderColor: "var(--border)", color: "var(--foreground)" }}
        className={cn(
          "w-full h-full border text-xs rounded-md pl-7 pr-3 py-1.5 placeholder:text-muted-foreground focus:outline-none focus:border-primary focus:ring-1 focus:ring-ring/50 transition-colors hover:border-primary",
          inputClassName,
        )}
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => onChange("")}
          className="absolute inset-y-0 right-1 my-auto h-6 w-6 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </Button>
      )}
    </div>
  );
}
